import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'

import Badge from 'components/common/Badge'
import { Client } from 'types/api/attacks/client'
import { Execution } from 'types/api/attacks/details/execution'
import { getColorForClientState, getColorForClientStatus } from 'utils/colors'

export const ExecutionHostStatus: React.FC<{ execution: Execution }> = ({
  execution,
  ...rest
}) => {
  const { exposeClientStatus: isExposeClientStatusEnabled } = useFlags()
  if (!isExposeClientStatusEnabled) {
    return null
  }

  const clientStatus = execution.client_status
  const statusColor = getColorForClientStatus(execution.client_status)

  return (
    <ClientStatus
      clientStatus={clientStatus}
      statusColor={statusColor}
      {...rest}
    />
  )
}

const ClientHostStatus: React.FC<{ client: Client }> = ({
  client,
  ...rest
}) => {
  const { exposeClientStatus: isExposeClientStatusEnabled } = useFlags()
  const clientStatus =
    isExposeClientStatusEnabled && client.validation_results?.client_status
      ? client.validation_results?.client_status
      : client.state

  const statusColor =
    isExposeClientStatusEnabled && client.validation_results?.client_status
      ? getColorForClientStatus(client.validation_results?.client_status)
      : getColorForClientState(client.state)

  return (
    <ClientStatus
      clientStatus={clientStatus}
      statusColor={statusColor}
      {...rest}
    />
  )
}

const ClientStatus: React.FC<{ clientStatus: string; statusColor: string }> = ({
  clientStatus,
  statusColor,
  ...rest
}) => {
  // If we didn't compute something valid, show nothing
  if (!clientStatus || !statusColor) {
    return null
  }

  return (
    <Badge
      data-test-host-status
      css={{
        backgroundColor: statusColor
      }}
      {...rest}
    >
      {clientStatus}
    </Badge>
  )
}

export default ClientHostStatus
